var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69107 3.5587L1.30795 7.99031C1.06402 8.23695 1.06402 8.63805 1.30795 8.88469L5.69107 13.3163C5.93332 13.5612 6.32479 13.5612 6.56705 13.3163C6.81098 13.0697 6.81098 12.6686 6.56705 12.4219L3.20482 9.0225H16.3125L16.4136 9.01344C16.676 8.96581 16.875 8.73614 16.875 8.46C16.875 8.14934 16.6232 7.8975 16.3125 7.8975H3.15659L6.56705 4.45308C6.81098 4.20644 6.81098 3.80533 6.56705 3.5587C6.32479 3.31377 5.93332 3.31377 5.69107 3.5587Z",
    fill: "#8A8E96"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3947:36503",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 16,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69107 3.5587L1.30795 7.99031C1.06402 8.23695 1.06402 8.63805 1.30795 8.88469L5.69107 13.3163C5.93332 13.5612 6.32479 13.5612 6.56705 13.3163C6.81098 13.0697 6.81098 12.6686 6.56705 12.4219L3.20482 9.0225H16.3125L16.4136 9.01344C16.676 8.96581 16.875 8.73614 16.875 8.46C16.875 8.14934 16.6232 7.8975 16.3125 7.8975H3.15659L6.56705 4.45308C6.81098 4.20644 6.81098 3.80533 6.56705 3.5587C6.32479 3.31377 5.93332 3.31377 5.69107 3.5587Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3947:36503)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowGrey);
export default __webpack_public_path__ + "static/media/back-arrow-grey.306d55552e10325c4686da521dd6944b.svg";
export { ForwardRef as ReactComponent };